module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile-doc column",
    on: {
      "click": _vm.download
    }
  }, [_c('div', {
    staticClass: "ctn-icon-document"
  }, [_c('img', {
    attrs: {
      "src": _vm.baseFile,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "extension"
  }, [_vm._v("." + _vm._s(_vm._f("uppercase")(_vm.doc.name)))])]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.doc.original_name) + "\n\t")]), _vm._v(" "), (_vm.doc.created_at) ? _c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\tAjouté le " + _vm._s(_vm.doc.created_at) + "\n\t")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0db2026a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/tile-doc.vue
// module id = 1068
// module chunks = 0